import { Fragment, useEffect, useRef, useState } from "react";
import _ from "../../i18n";
import { IconChevronDown, IconClose, IconPlus } from "../common/Icons";
import styles from "./Forfait.module.scss";
import { toast } from "react-toastify";
import { getForfaitRemarks, saveForfaitRemarks } from "../../api";
import { getRevision, saveRevision, saveForfait } from "../../api";
import { useQuery } from "react-query";
import { TiArrowSortedDown } from "react-icons/ti";
import { renderTeamYears, useOnClickOutside } from "../../utils";
import { Collapse } from "antd";

const { Panel } = Collapse;

export default function ForfaitSidePanel({
  visible,
  onClose,
  client,
  organization,
  token,
  year,
  reviewStatus,
  refetchReviewStatus,
}) {
  const ref = useRef();
  useOnClickOutside(ref, () => setYearDivIsVisible(false));
  const [analyseCauses, setAnalyseCauses] = useState("");
  const [analyseForfaits, setAnalyseForfaits] = useState("");
  const [proposals, setProposals] = useState("");
  const [remarks, setRemarks] = useState("");
  const [data, setData] = useState({});
  const [viewList, setViewList] = useState(true);
  const [selectedForfait, setSelectedForfait] = useState(null);
  const [yearDivIsVisible, setYearDivIsVisible] = useState(false);
  const [forfaits, setForfaits] = useState([null]);
  const [filter, setFilter] = useState({
    year: new Date().getFullYear(),
  });

  const handleCancelSidePanel = () => {
    setAnalyseCauses("");
    setAnalyseForfaits("");
    setProposals("");
    setRemarks("");
    setViewList(true);
    fetchForfaitRemarks();
  };

  const validated =
    analyseCauses.trim() !== "" ||
    analyseForfaits.trim() !== "" ||
    proposals.trim() !== "";
  const handleValidation = () => {
    if (!validated && remarks.trim() === "") {
      toast.error(_("At Least One Is Required"));
      return false;
    }
    return true;
  };

  const handleSave = () => {
    if (handleValidation()) {
      const data = {
        cause: analyseCauses,
        clientId: client,
        organization,
        year: filter.year,
        proposal: proposals,
        forfaitId: selectedForfait,
        analyse: analyseForfaits,
        remark: remarks,
        token,
      };

      saveRevision(data)
        .then((resp) => {
          if (resp.data.result === "OK") {
            toast.success(_("successfully_added"));
            refetchReviewStatus();
          }
        })
        .catch((e) => {
          if (
            e.response &&
            e.response.data &&
            e.response.data.errors &&
            e.response.data.errors.length > 0
          )
            toast.error(_(e.response.data.errors[0].message));
          else toast.error(_("error"));
        })
        .finally(() => {
          handleCancelSidePanel();
        });
    }
  };
  const handleCreateForfait = async () => {
    const dataToSend = {
      token,
      client: client,
      organization: organization,
      year: filter.year,
    };

    try {
      const resp = await saveForfait(dataToSend);

      if (resp.data.result === "OK") {
        toast.success(_("revision créé avec succès"));

        const response = await getRevision(
          token,
          organization,
          client,
          filter.year
        );
        const itemsByForfait = response.data.data;

        setData(itemsByForfait);

        const forfaitIds = Object.keys(itemsByForfait);
        if (forfaitIds.length > 0) {
          const lastForfaitId = forfaitIds[forfaitIds.length - 1];
          setSelectedForfait((prev) => {
            return prev !== lastForfaitId ? lastForfaitId : prev;
          });
        }
        refetchReviewStatus();
      } else {
        toast.error(_("Erreur lors de la création du revision"));
      }
    } catch (e) {
      toast.error(_("Erreur lors de la création du revision"));
      console.error(e);
    }
  };

  const fetchForfaitRemarks = async () => {
    if (token && organization && client) {
      try {
        const response = await getRevision(
          token,
          organization,
          client,
          filter.year
        );
        const itemsByForfait = response.data.data;
        setData(itemsByForfait);

        const forfaitIds = Object.keys(itemsByForfait);
        if (forfaitIds.length > 0) {
          setSelectedForfait(forfaitIds[0]);
        } else {
          setSelectedForfait(null);
        }
      } catch (e) {
        throw new Error(e.message);
      }
    }
  };

  useQuery(
    ["getRevision", token, organization, client, filter.year],
    fetchForfaitRemarks,
    { enabled: !!token && !!organization && !!client && !!filter.year }
  );

  useEffect(() => {
    fetchForfaitRemarks();
  }, [filter.year]);

  const renderYearSelect = () => {
    return (
      <div
        ref={ref}
        className={
          "customed_select" +
          " " +
          (yearDivIsVisible ? "customed_select_opened" : "")
        }
        style={{
          background: "#6d7f92",
          color: "#ffffff",
          zIndex: 99999,
        }}
      >
        <div
          className={"customed_select_header"}
          onClick={() => setYearDivIsVisible(!yearDivIsVisible)}
        >
          <span>{filter.year}</span>
          <div className={"actions"}>
            <div>
              <span className={"action"}>
                <TiArrowSortedDown />
              </span>
            </div>
          </div>
        </div>
        {yearDivIsVisible && (
          <div className={"customed_select_body"}>
            <div className={"customed_select_body_options"}>
              {renderTeamYears().map((item, index) => (
                <div
                  key={index}
                  className={"customed_select_body_option"}
                  onClick={() => setFilter({ ...filter, year: item })}
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      {visible ? (
        <div
          className={`sidebar ${styles.sidebar} paddingTop`}
          style={{ transform: "translateX(0)", zIndex: 10000 }}
        >
          <div className="sidebar_header">
            <h2>{_("revisionForfait")}</h2>
            <div onClick={onClose} style={{ cursor: "pointer" }}>
              <IconClose />
            </div>
          </div>
          <div className={styles.sidebar_content}>
            {viewList ? (
              <div className={styles.sidebar_content__list}>
                <div className={styles.sidebar_content__list_head}>
                  <h3> </h3>
                  <div className={styles.container_header_filter}>
                    {renderYearSelect()}
                    {selectedForfait && (
                      <div
                        onClick={() => {
                          setViewList(false);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <IconPlus size={25} />
                      </div>
                    )}
                  </div>
                </div>

                {data && Object.keys(data).length > 0 ? (
                  <div>
                    <div className={styles.forfait__tabs}>
                      {Object.keys(data).map((forfaitId, index) => (
                        <div
                          key={forfaitId}
                          className={`${styles.forfait__tab_header} ${
                            selectedForfait === forfaitId
                              ? styles.forfait__tab_header_active
                              : ""
                          }`}
                          onClick={() => setSelectedForfait(forfaitId)}
                        >
                          {`Revision ${index + 1}`}
                        </div>
                      ))}
                      <div
                        onClick={() => {
                          if (reviewStatus !== "IN_REVIEW") {
                            handleCreateForfait();
                          }
                        }}
                        style={{
                          cursor:
                            reviewStatus === "IN_REVIEW"
                              ? "not-allowed"
                              : "pointer",
                          opacity: reviewStatus === "IN_REVIEW" ? 0.5 : 1,
                          backgroundColor: "#6d7f9250",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          padding: 5,
                          borderRadius: "100%",
                        }}
                      >
                        <IconPlus fill="#29394d" size={15} />
                      </div>
                    </div>
                    <div className={styles.forfait__tab_content}>
                      {selectedForfait &&
                      data[selectedForfait] &&
                      data[selectedForfait].length > 0 ? (
                        <Collapse defaultActiveKey={["1"]} accordion>
                          <Panel header="Cause" key="1">
                            {data[selectedForfait].map((item, index) =>
                              item.cause ? (
                                <p key={`cause-${index}`}>{item.cause}</p>
                              ) : null
                            )}
                          </Panel>
                          <Panel header="Analyse" key="2">
                            {data[selectedForfait].map((item, index) =>
                              item.analysis ? (
                                <p key={`analysis-${index}`}>{item.analysis}</p>
                              ) : null
                            )}
                          </Panel>
                          <Panel header="Proposition" key="3">
                            {data[selectedForfait].map((item, index) =>
                              item.proposal ? (
                                <p key={`proposal-${index}`}>{item.proposal}</p>
                              ) : null
                            )}
                          </Panel>
                          <Panel header="Remarque" key="4">
                            {data[selectedForfait].map((item, index) =>
                              item.remark ? (
                                <p key={`remark-${index}`}>{item.remark}</p>
                              ) : null
                            )}
                          </Panel>
                        </Collapse>
                      ) : (
                        <div className="no_data">
                          <div className={styles.container_header_filter}></div>
                          <div className="title">
                            {_("Aucune remarque trouvée !")}
                          </div>
                          <div
                            className="subTitle"
                            style={{ cursor: "pointer" }}
                            onClick={() => setViewList(false)}
                          >
                            {_("+ Ajouter Nouveau")}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="no_data">
                    <div className={styles.container_header_filter}></div>
                    <div className="title">
                      {_("Aucune révision trouvée !")}
                    </div>
                    <div
                      className="subTitle"
                      style={{ cursor: "pointer" }}
                      onClick={handleCreateForfait}
                    >
                      {_("+ Lancer Révision")}
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <>
                <TextArea
                  label={_("cause")}
                  value={analyseCauses}
                  onChange={(e) => setAnalyseCauses(e.target.value)}
                />
                <TextArea
                  label="Analyse des forfaits"
                  value={analyseForfaits}
                  onChange={(e) => setAnalyseForfaits(e.target.value)}
                />
                <TextArea
                  label="Proposition"
                  value={proposals}
                  onChange={(e) => setProposals(e.target.value)}
                  rows={8}
                />
                <TextArea
                  label="remarque"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  rows={8}
                />

                <div className={styles.action_button}>
                  <div
                    className={`${styles.action_button__item} ${styles.button_save}`}
                    onClick={handleSave}
                    style={{
                      cursor: validated ? "pointer" : "not-allowed",
                      opacity: validated ? 1 : 0.5,
                    }}
                  >
                    {_("save")}
                  </div>
                  <div
                    className={`${styles.action_button__item} ${styles.button_cancel}`}
                    onClick={handleCancelSidePanel}
                  >
                    {_("cancel")}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export const TextArea = ({ label, value, onChange, rows = 5 }) => {
  return (
    <div className={styles.forfait__textarea}>
      <label className={styles.forfait__textarea_label}>{label}</label>
      <textarea
        className={styles.forfait__textarea_textarea}
        placeholder={_(`Description des ${label}`)}
        cols={60}
        rows={rows}
        value={value}
        onChange={onChange}
      ></textarea>
    </div>
  );
};

export const RemarksList = ({ label, remarks }) => {
  return (
    <div
      className={styles.forfait__remarks_list}
      style={{ padding: "5px 10px" }}
    >
      {remarks && (
        <Fragment>
          <div className={styles.forfait__remarks_list__head}>
            <h4>{label}</h4>
          </div>
          <div>
            {remarks.map((remark, index) => (
              <li
                key={`remark-${index}`}
                className={styles.forfait__remarks_list__item}
              >
                {`${index + 1}. ${remark}`}
              </li>
            ))}
          </div>
        </Fragment>
      )}
    </div>
  );
};
